import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { common as sr } from './local/sr/common';
import { common as en } from './local/en/common';

const savedLanguage = localStorage.getItem('promedia-language');

const initialLanguage =
  savedLanguage === 'sr' || savedLanguage === 'en' ? savedLanguage : 'sr';

i18n.use(initReactI18next).init({
  resources: {
    sr: {
      common: sr,
    },
    en: {
      common: en,
    },
  },
  lng: initialLanguage,
  fallbackLng: 'sr',
  interpolation: {
    escapeValue: false,
  },
});


export default i18n;
